import { ConfigProvider } from 'antd';
import en_US from 'antd/locale/en_US';
import tr_TR from 'antd/locale/tr_TR';
import { useTranslation } from 'react-i18next';

import { CurrencyProvider } from '@/contexts/CurrencyContext';

import OrganizationHelmet from './components/OrganizationHelmet';
import useAuth, { UserProvider } from './hooks/useAuth';
import MobileWarningOverlay from './pages/MobileWarningOverlay';
import AllRoutes from './routes';
import GlobalStyles from './theme/GlobalStyles';
import Token from './theme/token';
import '@fontsource/montserrat/900.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/100.css';
import '@fontsource/lato';
import '@fontsource/inter';

function AppContent() {
  const { i18n } = useTranslation();
  const { user } = useAuth();

  const antdLocale = i18n.language === 'tr' ? tr_TR : en_US;

  return (
    <ConfigProvider theme={Token()} locale={antdLocale}>
      <CurrencyProvider>
        <GlobalStyles />
        <OrganizationHelmet
          organizationId={user?.organization.id}
          defaultTitle={user?.organization.name}
        />
        <MobileWarningOverlay />
        <AllRoutes />
      </CurrencyProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}

export default App;
